import { createSelector } from 'reselect'
import { get } from 'lodash/fp'
import _ from 'lodash'
import { getFna } from '../selectors'
import { isFNAFlow } from 'quick-quote/portal/selectors'
import { getSelectedDisplayProductQuery } from 'quick-quote/product-selection/selectors'

export const getSuitability = createSelector(getFna, get('suitability'))
export const getSuitabilityQuestionaire = createSelector(getFna, get('suitability.suitabilityQuestionaire'))
export const getSuitabilityAnswers = createSelector(getFna, get('suitability.suitabilityAnswers'))
export const getSuitabilityScore = createSelector(getFna, get('suitability.suitabilityScore'))
export const getSuitabilityStatus = createSelector(getFna, get('suitability.suitabilityStatus'))

export const isProductCategoryIndexLinked = createSelector(
  getSelectedDisplayProductQuery,
  (selectedDisplayProductQuery) => {
    return selectedDisplayProductQuery.category === 'INDEX_LINKED'
  }
)

export const getIsCompletedSuitabilityTested = createSelector(
  getSelectedDisplayProductQuery,
  getSuitabilityStatus,
  isFNAFlow,
  (selectedDisplayProductQuery, suitabilityStatus, fnaFlow) => {
    return selectedDisplayProductQuery.category === 'INDEX_LINKED' && fnaFlow ? suitabilityStatus === true : true
  }
)
